"use client";
import { setupDayjs } from "@/lib/dayjs/setup";
import { Cookies } from "../ui";
import { EmotionRegistry } from "./EmotionRegistry";

// Configura el locale de dayjs una sola vez al cargar el módulo (no en cada render).
setupDayjs({ locale: "es" });

function Providers({ children }: { children: React.ReactNode }) {
	return (
		<EmotionRegistry>
			{children}
			<Cookies />
		</EmotionRegistry>
	);
}

export default Providers;
